<template lang="pug">
  .header#picture(
    :style='{"background-image": `url("${contentPicture}")`}'
    @mouseenter='toggleImageActions(true)'
    @mouseleave='toggleImageActions(false)'
  )
    .header-container.row.space-between
      v-popover.self-end(
        @apply-hide='resetAction'
        placement='bottom-start'
        :delay='{show: 100, hide: 600}'
        trigger='hover click'
        popoverClass='krea-actions-popover'
        :container='false'
      )
        button.no-border.rounded.with-icon.m-bottom-2(@click='showModal' :class='activeContentLanguage.youtubeLink ? "primary-button" : "terciary-button"')
          simple-svg.white-icon.m-right-1(:filepath='playIcon' width='20px' height='20px')
          | {{ !activeContentLanguage.youtubeLink ? innerI18n.t('krea.educationalContent.header.uploadVideo') : innerI18n.t('krea.educationalContent.header.watchVideo') }}
        template(slot='popover')
          actions(
            ref='videoAction'
            :linkValue='activeContentLanguage.youtubeLink'
            @updatedLink='editVideoLink'
            @removedLink='removeVideoLink'
            @removeFile='removeVideoLink'
            placement='start'
            link
            :info='youtubeLinkInfo'
          )
      v-popover(
        @apply-hide='resetAction'
        placement='bottom-end'
        :delay='{show: 100, hide: 600}'
        trigger='hover click'
        :open='showImageActions'
        popoverClass='krea-actions-popover'
        :container='false'
      )
        button.no-border.terciary-button.with-icon.m-top-2.upload-image(@click='showFileModal' :class='{hidden: content.picture}')
          simple-svg.white-icon.m-right-1(:filepath='cameraIcon' width='18px' height='18px')
          | {{ innerI18n.t('krea.educationalContent.header.uploadImage') }}
        template(slot='popover')
          actions(
            ref='imageAction'
            :class='{"m-top-2": content.picture}'
            placement='end'
            :fileValue='content.picture'
            @removeFile='editPicture("")'
            kreaContentImage
            @kreaContentImage='showFileModal'
            :updateFile='editPicture'
            :info='imageInfo'
          )
</template>

<script>
import playIcon from '@/assets/ic_play.svg'
import cameraIcon from '@/assets/krea/ic_camera.svg'
import Actions from '@/components/Krea/Inputs/Actions/Actions'
import { contentType } from '../../../utils/constants'
import { innerI18n } from '../../../main'
import { mapActions, mapState } from 'vuex'
import { languagesCodesToString } from '../../../constants/languages'

export default {
  components: { Actions },
  props: {
    toggleVideo: { type: Function, required: true }
  },
  data() {
    return {
      playIcon,
      cameraIcon,
      innerI18n,
      showImageActions: false
    }
  },
  computed: {
    ...mapState({
      content: state => state.kreaEducationalContent.content,
      activeLanguage: state => state.kreaEducationalContent.activeLanguage,
      innerLocale: state => state.behavior.innerLocale
    }),
    contentPicture() {
      if (/[\s()]+/.test(this.content.picture)) return encodeURI(this.content.picture)
      else return this.content.picture
    },
    kreaContentGuide() {
      return process.env[`VUE_APP_KREA_CREATE_CONTENT_GUIDE_${this.innerLocale}`]
    },
    activeContentLanguage() {
      return this.content.localizedEducationalPrograms.find(pr => languagesCodesToString[pr.locale] === this.activeLanguage)
    },
    contentTypeTranslation() {
      const contentTypeName = Object.keys(contentType).find(key => this.content.contentType === contentType[key])
      return innerI18n.t(`krea.educationalContent.${contentTypeName}`).toLowerCase()
    },
    youtubeLinkInfo() {
      return {
        title: innerI18n.t('krea.educationalContent.header.uploadVideoInfoTitle'),
        guideLink: { msg: innerI18n.t('krea.educationalContent.details.contentGuideName'), link: this.kreaContentGuide },
        tips: [innerI18n.t('krea.educationalContent.header.uploadVideoInfo', { content: this.contentTypeTranslation })]
      }
    },
    imageInfo() {
      return {
        title: innerI18n.t('krea.educationalContent.header.uploadImageInfoTitle', { content: this.contentTypeTranslation }),
        guideLink: { msg: innerI18n.t('krea.educationalContent.details.contentGuideName'), link: this.kreaContentGuide },
        tips: [innerI18n.t('krea.educationalContent.header.uploadImageInfo')]
      }
    }
  },
  methods: {
    ...mapActions([
      'editKreaLocalizedContentField',
      'editKreaContentField',
      'showElement'
    ]),
    showModal() {
      if (this.activeContentLanguage.youtubeLink) this.toggleVideo()
      else {
        this.showElement({
          element: 'kreaFileUploaderModal',
          props: {
            type: 'video',
            link: true,
            linkType: 'video',
            updateLink: this.editVideoLink,
            updateFile: this.editVideoLink
          }
        })
      }
    },
    showFileModal() {
      this.showElement({ element: 'kreaContentImageModal' })
    },
    toggleImageActions(value) {
      if (this.content.picture) {
        this.showImageActions = value
      }
    },
    editVideoLink(value) {
      this.editKreaLocalizedContentField({ field: 'youtubeLink', value, locale: this.activeLanguage })
    },
    removeVideoLink() {
      this.editKreaLocalizedContentField({ field: 'youtubeLink', value: null, locale: this.activeLanguage })
    },
    editPicture(value) {
      this.editKreaContentField({ field: 'picture', value })
    },
    resetAction() {
      if (this.$refs.videoAction) this.$refs.videoAction.resetAction()
      if (this.$refs.imageAction) this.$refs.imageAction.resetAction()
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/sizes';
@import 'src/scss/variables/colors';

.header {
  width: 100%;
  height: 300px;
  background-color: #D9D9D9;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  .header-container{
    height: 100%;
    max-width: $content-size;
    margin: 0 auto;
  }
}

.upload-image{
  &.hidden{
    display: none;
  }
}
</style>
